import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { DetailsErrorSource } from "@/hooks/trips/useFilteredTrips";
import { demystifyError } from "@/utilities/error/demystifyError";
import { ResultsCapError } from "@/utilities/error/ResultsCapError";

interface Props {
  source: DetailsErrorSource | null;
  annotationsError: Error | null;
}

/** Names the trip detail load that failed and, for a capped annotation read, why. */
export function TripDetailsErrorLines({ source, annotationsError }: Props) {
  const { t } = useTranslation();
  const text: Record<DetailsErrorSource, string> = {
    devices: t("logbookCheck.detailsLoadError.devices"),
    users: t("logbookCheck.detailsLoadError.users"),
    annotations: t("logbookCheck.detailsLoadError.annotations"),
  };
  return (
    <>
      {source && <Typography variant="body2">{text[source]}</Typography>}
      {annotationsError instanceof ResultsCapError && (
        <Typography variant="body2">{demystifyError(t, annotationsError)}</Typography>
      )}
    </>
  );
}
